var render, staticRenderFns
import script from "./ChartScatter.vue?vue&type=script&lang=js"
export * from "./ChartScatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f90787",
  null
  
)

export default component.exports